import { render, staticRenderFns } from "./mars.vue?vue&type=template&id=d83b6830&scoped=true&"
import script from "./mars.vue?vue&type=script&lang=js&"
export * from "./mars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83b6830",
  null
  
)

export default component.exports